const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreGraduate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M11.2,10.1l2.9,0.9c0.3,0.1,0.6,0.3,0.8,0.6 c0.3,0.5,0.5,1.3,0.5,2.8v3.9H9.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.1,18.3H4.9v-3.9c0-1.5,0.2-2.3,0.5-2.8 c0.2-0.3,0.5-0.5,0.8-0.6l3-0.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "10.7,14.9 10.2,12.4 10.6,11.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "9.6,11.8 9.9,12.4 9.6,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M11.1,10.5L11,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.3,9.6l-0.1,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.3,12.3l0.8-1.1c-0.9-0.1-1.1-1-1.1-1l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M11.3,10.2L11.3,10.2c-0.1-0.1-0.2,0.9-1.2,1 l0.9,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.3,13.1v5.1 C13.3,18.3,13.3,13.6,13.3,13.1L13.3,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M6.9,13.1v5.1C6.9,18.3,6.9,13.6,6.9,13.1 L6.9,13.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "9,10.2 9.9,17.7 8.1,14.1 8.6,13.5  7.6,12.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "11.2,10.2 10.4,17.6 12.1,13.8  11.6,13.2 12.6,12.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.2,5.9C8.1,6.1,8,6.4,8,6.7l0,0 C7.7,6.8,7.6,7.1,7.7,7.4c0,0.2,0.2,0.3,0.3,0.4c0.2,1.2,1.1,2,2.2,2s2-0.9,2.2-2.2c0.1-0.1,0.2-0.2,0.2-0.3 c0.1-0.3,0-0.6-0.2-0.6c-0.1-0.3-0.1-0.6-0.3-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M12,5.8c0.1,0.1,0.2,0.1,0.2,0.3 c0,0.3,0.1,1.3,0.1,1.3s0.1-0.6,0.1-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8,5.9c0,0.7,0.1,1.6,0.1,1.6s0.1-1,0.1-1.3 c0-0.5,0.7,0,1.8-0.1c0.4,0,0.8-0.3,1-0.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "7.8,3.6 6.2,3 10.1,1.4 14.1,3  12.6,3.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.8,3.4L8,6c0,0,2.2-0.9,4.4,0l0.2-2.6 C12.5,3.4,10.5,2.2,7.8,3.4z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 6.8,
    y1: 3,
    x2: 6.8,
    y2: 4.4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "6.8,4.6 6.4,6 7.2,6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7,4.5c0,0.1-0.1,0.2-0.2,0.2S6.6,4.6,6.6,4.5 s0.1-0.2,0.2-0.2S7,4.4,7,4.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreGraduate);
export default __webpack_public_path__ + "static/media/pre_graduate.e6c402a2e22f0d04aa5c8f68864a6f6f.svg";
export { ForwardRef as ReactComponent };